import { boundMethod } from 'autobind-decorator'

import { PurchasingOption } from './purchasing_option'

export class PurchasingOptionBuyNow extends PurchasingOption {
  constructor(element: HTMLElement) {
    super(element)

    this.gaPurchasingType = 'BIN'
  }

  @boundMethod activate() {
    $(this.element).trigger('purchase-option', this)
  }
}
